sf.ready(function() {

    // sf('img').each(function (elem) {
    //     var image = elem;
    //     elem.onclick = function () {
    //         sf.zoomImg(image.src);
    //         return false;
    //     }
    // });

});
